import { EffectCallback, useEffect, useRef } from "react";

const useEffectOnce = (effect: EffectCallback) => {
  // TODO: This started erroring as part of the react 17 upgrade. May be
  //       worth a closer look the next time we are in here
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, []);
};

const useUnmount = (fn: () => any): void => {
  const fnRef = useRef(fn);

  fnRef.current = fn;

  useEffectOnce(() => () => fnRef.current());
};

export default useUnmount;
